import { render, staticRenderFns } from "./TripleCare.vue?vue&type=template&id=ea583550"
import script from "./TripleCare.vue?vue&type=script&lang=js"
export * from "./TripleCare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports